import * as Yup from 'yup';

const schema = Yup.object().shape({
  valor: Yup.string().required('Valor requerido'),
  // potencial_poluidor_id: Yup.string().required('Valor requerido'),
  porte_empreendimento_id: Yup.string().required('Valor requerido'),
});

export default schema;
